<template>
    <div class="ratio">
        <div class="row justify-center items-center image cursor-pointer" :class="{'zoom': zoom}">
            <img @click.prevent="$watchUser('item', item)" v-lazy="img.url" :key="img.url"
                 :style="{'object-position': img.focalPoint ? img.focalPoint : false}">
            <div v-if="isVideo" class="has-video"></div>
            <div v-if="time" class="videoDuration" title="Duração do vídeo"> {{time}}</div>
            <div v-if="isView" class="fa fa-eye videoDuration" style="margin-top: 55px"> {{views}}</div>

        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'VImg',

        props: {
            img: {
                type: Object,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            isVideo: Boolean,
            zoom: {
              default: true,
              type: Boolean
            },
            time: '',
            views: '',
            isView: ''
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Image.vue